import React,{lazy} from "react";

const EWTitle = (props) => 
{
    const label = props.Label;
    const Icon = props.Icon !== undefined ? <></>: null;
    return <p><b>{label}</b><span><Icon fontSize = "medium"/></span></p>
}

export default EWTitle;